
import AppEmaillogsIndex from "./emailLogs.vue";
import AppEmaillogsList from "./list/list.vue";
import AppEmaillogsItem from "./item/item.vue";

const routes = [
  {
    path: "/be/emailLogs",
    component: AppEmaillogsIndex,
    meta: {
      auth: {
        roles: "emailLogs.index",
        redirect: { name: "auth.login" },
        forbiddenRedirect: "/403"
      }
    },
    children: [
      {
        path: "",
        name: "emailLogs.index",
        component: AppEmaillogsList,
        meta: {
          auth: {
            roles: "emailLogs.index",
            redirect: { name: "auth.login" }
          }
        }
      },
      {
        path: "create",
        name: "emailLogs.create",
        component: AppEmaillogsItem,
        meta: {
          auth: {
            roles: "emailLogs.create",
            redirect: { name: "emailLogs.index" }
          }
        }
      },
      {
        path: ":id",
        name: "emailLogs.show",
        component: AppEmaillogsItem,
        meta: {
          auth: {
            roles: "emailLogs.index",
            redirect: { name: "emailLogs.index" }
          }
        }
      }
    ]
  }
];

export default routes;
